module.exports = __webpack_public_path__ + "static/media/IKMS06.0a457297.jpg";